const buttons = document.querySelectorAll('.buttons div');
const boxDrop = document.querySelector('.pm');
const boxContainer = document.querySelector('.pm ul');
const pmSubmit = document.getElementById('AddToCart-product-pm-template');
const pmCount = document.querySelector('.in-pm');
const randomize = document.getElementById('randomPm');
const clearAll = document.getElementById('clearAll');
const form = document.querySelector('.product-form');
let candyInPm = 0;
let pmCheck;

function getRandomString(length) {
  var randomChars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
  var result = '';
  for (var i = 0; i < length; i++) {
    result += randomChars.charAt(
      Math.floor(Math.random() * randomChars.length)
    );
  }
  return result;
}

pmSubmit.disabled = true;

window.addEventListener('DOMContentLoaded', (event) => {
  //boxDrop.style.height = boxDrop.offsetWidth + 12 + 'px';
  boxDrop.style.height = 'auto';
});

window.addEventListener('resize', (event) => {
  boxDrop.style.height = boxDrop.offsetWidth + 12 + 'px';
});

buttons.forEach((button) => {
  button.addEventListener('click', function (e) {
    addCandyToPm(e.currentTarget.dataset);
    e.currentTarget.classList.add('added');
  });
  button.addEventListener('dragstart', function (e) {
    e.dataTransfer.setData('Text', JSON.stringify(e.currentTarget.dataset));
    e.currentTarget.classList.add('added');
  });
});

boxDrop.addEventListener('dragenter', function (e) {
  e.preventDefault();
});

boxDrop.addEventListener('dragover', function (e) {
  e.preventDefault();
});

boxDrop.addEventListener('drop', function (e) {
  e.preventDefault();
  let itemToAdd = e.dataTransfer.getData('Text');
  addCandyToPm(JSON.parse(itemToAdd));
  e.dataTransfer.clearData();
});

function clearPm() {
  let productsAdded = document.querySelectorAll('.added');
  boxContainer.innerHTML = '';
  candyInPm = 0;
  pmCount.textContent = candyInPm + 'g';
  pmSubmit.disabled = true;
  productsAdded.forEach((item) => {
    item.classList.remove('added');
  });
}

function clearCandy(e) {
  let productsAdded = document.querySelectorAll('.added');
  productsAdded.forEach((item) => {
    if (item.dataset.itemHandle == e.currentTarget.children[2].name) {
      item.classList.remove('added');
    }
  });
  e.currentTarget.remove();
  candyInPm = candyInPm - 1;
  pmCount.textContent = candyInPm + 'g';
  if (candyInPm < 1) {
    pmSubmit.disabled = true;
    pmSubmit.textContent = 'Add more candy';
  }
}

function randomPm() {
  clearPm();
  let candyCount = buttons.length;
  let i = 1;
  let listData = [];
  while (i <= 6) {
    let selection = Math.floor(Math.random() * candyCount);
    let element = buttons[selection];
    let candyData = {
      data: element.dataset,
    };
    listData.push(candyData);
    i++;
  }
  listData.forEach((element) => {
    addCandyToPm(element.data);
  });
}

randomize.addEventListener('click', randomPm);
clearAll.addEventListener('click', clearPm);

function addCandyToPm(data) {
  if (boxContainer.children.length < 12) {
    candyInPm = candyInPm + 1;
    let item = document.createElement('li');
    item.innerHTML = `
            <img src="${data.itemImg}" />
            <h4 style="display:none;">${data.itemTitle}</h4>
            <input type="hidden" class="pm-candy" name="${data.itemHandle}" value="${data.itemId}" />
        `;
    //item.innerHtml = itemHtml;
    boxContainer.appendChild(item);
    item.addEventListener('click', clearCandy);
  } else {
    console.log("Your pick'n'mix is ready to go!");
  }
  if (boxContainer.children.length > 1) {
    pmSubmit.disabled = false;
    pmSubmit.textContent = 'Add to cart';
  } else {
    pmSubmit.disabled = true;
    pmSubmit.textContent = 'Add more candy';
  }
  if (candyInPm * 150 >= 1000) {
    pmCount.textContent = (candyInPm * 150) / 1000 + 'kg';
  } else {
    pmCount.textContent = candyInPm * 150 + 'g';
  }

  if (candyInPm == 20) {
    form.scrollIntoView({ behaviour: 'smooth', block: 'center' });
  }
}

function getPmCount() {
  return parseInt(localStorage.getItem('pmNo'));
}

form.addEventListener('submit', function (e) {
  e.preventDefault();
  let pmQty = document.querySelector('.qty_input');
  let items = [];
  let inputs = document.querySelectorAll('form.product-form input.pm-candy');
  let pmCode = getRandomString(3);

  inputs.forEach((item) => {
    items.push({
      id: item.value,
      quantity: pmQty.value,
      properties: {
        '_pm ID': pmCode,
      },
    });
  });
  let formData = { items: items };
  fetch('/cart/add.js', {
    method: 'post',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify(formData),
  })
    .then((response) => response.json())
    .then((result) => {
      return fetch('/cart.js', {
        method: 'GET',
      });
    })
    .then((response) => response.json())
    .then((data) => {
      $.ajax({
        url: '/cart.js',
        dataType: 'json',
        success: function (cart) {
          $('#CartCount').show();
          $('.cart-counter').text(cart.item_count);
        },
      });
    })
    .catch((error) => console.log(error));
});
